<template>
    <div id="app">
        <Logo/>
        <GridLines/>
        <router-view/>
    </div>
</template>

<script>
    import GridLines from "@/components/GridLines.vue";
    import Logo from "@/components/Logo.vue";


    export default {
        name: 'app',
        components: {
            GridLines,
            Logo
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Poppins:200,300,700');


    /* INITIAL HOME ANIMATION */

    .appear-left-enter-active, .appear-left-leave-active {
        transition: margin-left .7s 1s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .appear-left-enter, .appear-left-leave-to {
        margin-left: -100%;
    }

    .appear-right-enter-active, .appear-right-leave-active {
        transition: margin-left .7s 1.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .appear-right-enter, .appear-right-leave-to {
        margin-left: -100%;
    }

    .appear-right2-enter-active, .appear-right2-leave-active {
        transition: margin-left .7s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .appear-right2-enter, .appear-right2-leave-to {
        margin-left: -100%;
    }

    .icon-enter-active, .icon-leave-active {
        transition: transform .5s 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    .icon-enter, .icon-leave-to {
        transform: scale(.01);
    }

    .icon2-enter-active, .icon2-leave-active {
        transition: transform .5s 1.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    .icon2-enter, .icon2-leave-to {
        transform: scale(.01);
    }

    .icon3-enter-active, .icon3-leave-active {
        transition: transform .5s 1.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    .icon3-enter, .icon3-leave-to {
        transform: scale(.01);
    }


    /* GENERAL ANIMATION */

    .slide-left-enter-active, .slide-left-leave-active {
        transition: margin-left .5s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .slide-left-enter, .slide-left-leave-to {
        margin-left: -100%;
    }

    .slide-right-enter-active, .slide-right-leave-active {
        transition: margin-right .5s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .slide-right-enter, .slide-right-leave-to {
        margin-right: -100%;
    }

    .slide-top-enter-active, .slide-top-leave-active {
        transition: margin-bottom .5s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .slide-top-enter, .slide-top-leave-to {
        margin-bottom: 100%;
    }

    .slide-bot-enter-active, .slide-bot-leave-active {
        transition: margin-top .5s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .slide-bot-enter, .slide-bot-leave-to {
        margin-top: 100%;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s 2s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }


    /* PROJECTS PREVIEW ANIMATION */

    .pop-enter-active {
        clip-path: circle(50%);
        transition: clip-path .5s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    .pop-enter {
        clip-path: circle(.01%);
    }

    .pop-leave-active {
        clip-path: circle(50%);
        opacity: 1;
        transition: clip-path .5s cubic-bezier(0.075, 0.82, 0.165, 1), opacity .5s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    .pop-leave-to {
        clip-path: circle(40%);
        opacity: 0;
    }

    .transition-wrapper {
        width: 100%;
    }


    /* GENERAL */

    * {
        margin: 0;
        box-sizing: border-box;
    }

    html {
        font-size: 1.7vh;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    body {
        background-color: rgba(244, 244, 244, 1);
    }

    ::selection {
        color: rgba(244, 244, 244, 1);
        background-color: rgba(57, 224, 151, 1);
    }


    /* TYPOGRAPHY */

    h1, h2, h3, h4, h5, div, section, body {
        font-family: 'Poppins', sans-serif;
        color: rgba(86, 86, 86, 1);
    }

    h2 {
        font-size: 2.5rem;
        font-weight: 200;
    }

    .section-head {
        margin-bottom: 1rem;
    }

    .section-subhead {
        font-weight: 700;
    }

    h3 {
        font-size: 1.5rem;
        font-weight: 200;
    }

    p {
        font-weight: 300;
        font-size: 1rem;
        line-height: 1.5rem;
    }

    a {
        text-decoration: none;
        color: rgba(57, 224, 151, 1);
        transition: color 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    a:hover {
        color: rgba(86, 86, 86, 1);
    }

    strong {
        font-weight: 700;
    }

    h2 strong {
        font-size: 2.5rem;
    }

    ul {
        list-style-type: none;
    }


    /* NAVIGATION & INTERACTION */

    header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 1;
    }

    header #menu {
        text-align: right;
        font-size: 1rem;
        line-height: 2rem;
    }

    header #menu li {
        display: block;
    }

    #social-bar {
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 1;
    }

    #social-bar .menu {
        text-align: right;
        line-height: 2.5rem;

    }

    #social-bar svg .social-icon {
        fill: rgba(57, 224, 151, 1);
        transition: fill 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    #social-bar svg:hover .social-icon {
        fill: rgba(86, 86, 86, 1);
    }

    .fixwrap {
        margin: 1.4rem;
        display: flex;
        justify-content: flex-end;
    }

    .btn {
        display: flex;
        margin-top: 1.4rem;
        max-width: 50%;
        transition: max-width 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    .btn div {
        margin-left: 1rem;
        background: right 60% no-repeat url("assets/svg/arrow-long.svg");
        min-width: 2.5rem;
        width: 100%;
    }

    .btn:hover {
        max-width: 100%;
    }

    .btn a {
        transition: color 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    .btn a:hover {
        color: rgba(86, 86, 86, 1);
    }

    .btn-back {
        display: flex;
        width: 50%;
        transition: width 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    .btn-back div {
        margin-right: 1rem;
        background: left 60% no-repeat url("assets/svg/arrow-long-left.svg");
        width: 100%;
    }

    .btn-back:hover {
        width: 100%;
    }

    /* COPY ITEM */

    #copy-mail {
        cursor: pointer;
        display: block;
        transition: color 0.3s;
    }

    #copy-mail:hover {
        color: rgba(57, 224, 151, 0.2);
    }

    #copy-mail::before {
        content: attr(data);
        color: rgba(57, 224, 151, 1);
        position: absolute;
        padding-top: 1.5rem;
        font-size: 1rem;
        font-weight: 300;
        margin-left: -16%;
        opacity: 0;
        transition: margin-left .3s, opacity .3s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    #copy-mail:hover::before {
        margin-left: -8%;
        opacity: 1;
    }

    #copy-mail:active {
        color: rgba(57, 224, 151, 1);
    }

    /* LAYOUT */

    .grid-section {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-template-rows: repeat(6, 1fr);
        margin-bottom: 10rem;
        height: 100vh;
    }

    .content {
        grid-column: 2 / 4;
        grid-row: 2 / 7;
        width: 100%;
        overflow: hidden;
    }

    .wrapper-go-to {
        width: 50%;
    }

    .wrapper-go-back {
        width: 50%;
        display: flex;
        justify-content: flex-end;
    }

    /*** SCREENS ***/

    /* Mobile: Portrait and Landscape */
    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {

        html {
            font-size: 14px;
        }

        header {
            border-bottom: 1px solid rgba(220, 220, 220, 1);
            background-color: rgba(244, 244, 244, 1);
        }

        .grid-section {
            display: block;
            margin-left: 2rem;
            margin-right: 2rem;
            margin-bottom: 2rem;
            height: auto;
            min-height: 100vh;

        }

        h2 {
            font-size: 2rem;
        }

        h2 strong {
            font-size: 2rem;
        }

        h3 {
            font-size: 1rem;
        }

        .btn {
            margin-top: 0.5rem;
        }

        .btn a:before {
            content: "";
            padding-left: 2rem;
            margin-right: 0.5rem;
            background: right 60% no-repeat url("assets/svg/arrow-long.svg");        }

        .btn div {
            background-image: none;
        }

        .wrapper-go-to {
            width: 100%;
        }

        #social-bar {
            display: none;
        }

        .section-head {

        }

        section {
            padding-top: 20vh;
        }
    }

</style>
